<script>
    import user from '../../stores/user'
    import { onMount, onDestroy, tick } from 'svelte'
    import { useLocation } from 'svelte-navigator'
    const location = useLocation()
    const validation = setInterval(async (_) => {
        if ($user) {
            user.validate($location.pathname)
            await tick()
        }
        // console.log('Validate login.')
    }, 500)
    onMount((_) => {
        validation
    })
    onDestroy((_) => {
        clearInterval(validation)
    })
    $: if (!$user) {
        let loc = $location.pathname
        user.logout('Se requiere inicio de sesión.', $location.pathname)
    }
</script>

{#if $user}
    <slot location={$location} user={$user} />
    <!-- {:else}
    {user.logout('Requiere inicio de sesion.', $location.pathname)} -->
{/if}
